// Whether the screen is at least 1024px wide (Tailwind's `lg`): for the few places that
// show a different control, not just a different layout, beside or below that width.
import { useSyncExternalStore } from 'react'

const query = typeof window === 'undefined' ? null : window.matchMedia('(min-width: 64rem)')

export function useWide(): boolean {
  return useSyncExternalStore(
    (onChange) => {
      query?.addEventListener('change', onChange)
      return () => query?.removeEventListener('change', onChange)
    },
    () => query?.matches ?? true,
  )
}
